import { makeAutoObservable } from 'mobx';
import stringUtil from '../clientUtils/stringUtil';

/**
 * 화폐 단위 변환 스토어
 */
class CurrencyStore {
    isKrwDisplay = false;
    exchangeRate = 1400;

    constructor() {
        makeAutoObservable(this);
    }

    toggleKrwDisplay() {
        this.isKrwDisplay = !this.isKrwDisplay;
    }

    toCompactUsdOrKrw(value: number, precision?: number) {
        if (this.isKrwDisplay) {
            return stringUtil.toCompactKrw(value * this.exchangeRate, precision);
        }

        return stringUtil.toCompactUsd(value, precision);
    }

    private async fetchExchangeRate() {
        // 원화 환율 가져옴
    }
}

export default new CurrencyStore();
